import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService } from '../services/index';
import { BNCCFormService } from '../services/bncc-form.service';
import { IBNCC } from '../models/bncc-model';


@Injectable()
export class BNCCFormResolverService implements Resolve<any> {
    revisionId: string;
    customerGuid: string;
    bnccForm: IBNCC = undefined;

  constructor (private bnccService: BNCCFormService, private storageManagerService: StorageManagerService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    //first check if formData exists on the route as 'state'  
    this.bnccForm = <IBNCC>this.router.getCurrentNavigation()?.extras?.state?.formData;

    const revisionId = route.params.revisionId;
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');
    const modifiedByUser = this.storageManagerService.read('userData')?.name;

    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
        if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
        }
    }

    const retVal = forkJoin([
          revisionId && !this.bnccForm ? this.bnccService.getBNCCForm(revisionId) : of({ data: this.bnccForm }),
          revisionId ? this.bnccService.getRevisionHistory(revisionId, modifiedByUser) : of(null)
        ])
        .pipe(catchError(err => of({ error: err })));

        return retVal;
    }
}
